import Image from "next/image"
import { useContext } from "react"
import { isMobileContext } from "../../contexts/isMobileContext"
import { BASE_URL } from "../../utils/FetchData"
import { motion, AnimatePresence } from "framer-motion"
import FadeIn from "../Animations/FadeIn"

const CommonBanner = ({ bannerData,pageLoading }) => {
    const { isMobile } = useContext(isMobileContext)
    return (
        <div className='common-banner'>
            <div className="overlay"></div>
            <div className="banner-image-container">
                {bannerData &&
                    <Image
                        src={BASE_URL + (isMobile ? bannerData?.img_mobile?.data?.attributes.url : bannerData?.img_desktop?.data?.attributes.url)}
                        alt={isMobile ? bannerData?.img_mobile?.data?.attributes?.name : bannerData?.img_desktop?.data?.attributes?.name}
                        layout="fill"
                        objectPosition={"top"}
                        objectFit="cover"
                        priority
                    />
                }
            </div>
            <FadeIn customClass="banner-text-data" pageLoading={pageLoading}>
                <h1 className="_eleX">{bannerData?.title}</h1>
                <div className='text-description _eleX'>
                    <p>{bannerData?.description}<br style={{ display: isMobile ? "none" : "" }} />{bannerData?.description2}</p>
                    {/* <p>{bannerData?.description}</p>
                    <p>{bannerData?.description2}</p> */}
                </div>
            </FadeIn>
        </div>
    )
}

export default CommonBanner
